import { type PropsWithChildren } from "react";

import { DOM_IDS } from "../defaults";

export const Body = ({ children }: Readonly<PropsWithChildren>) => (
  <div
    id={DOM_IDS.communityRightSidebarBody}
    data-testid="circle-ai-shell-panel-body"
    className="min-h-0 flex-1 overflow-auto"
  >
    {children}
  </div>
);

Body.displayName = "CircleAIAppShell.Layout.Panel.Body";
